import { actions } from "./actions";
import { initialState } from "./constants";

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_NOTIFICATIONS:
      return {
        ...state,
        getNotifications: {
          loading: true,
          success: false,
          data: [],
          error: null,
        },
      };
    case actions.GET_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        getNotifications: {
          loading: false,
          success: true,
          data: action.payload,
          error: null,
        },
      };
    case actions.GET_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        getNotifications: {
          loading: false,
          success: false,
          data: [],
          error: action.payload,
        },
      };
    default:
      return state;
  }
};
export { reducer, actions, initialState };
